import React from 'react';
import Label from '../Label';

const RoleCell = ({
  roleAssignments,
  accountId
}: any) => {
  const roleAssignment = roleAssignments.find((ra: any) => ra.account.id === accountId);

  if (!roleAssignment) return <span>&mdash;</span>;

  return (
    <Label color="success">
      {roleAssignment.role.name}
    </Label>
  );
};

export default RoleCell;
